import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { routeMap } from 'router';
import Field from 'components/Field';
import DateField from 'components/DateField';
import styles from '../ExternalAppointment.module.scss';
import Button, { BUTTON_COLORS } from 'components/Button';
import { get, isEmpty, some } from 'lodash';
import TaxAuthoritySelectContainer from 'modules/Contacts/containers/TaxAuthoritySelectContainer';
import { moment } from 'utils';
import DateFormats from 'constants/DateFormats';
import Select from 'components/Select';
import { SlotLoadingStatus } from './SlotLoadingStatus';
import { GET_ACCESS_TO_LK_FNS_SERVICE_ID, GET_ACCESS_TO_LK_SERVICE_NAME } from '../constants';
import { defaultFaceId } from 'modules/Contacts/components/MakeAppointment';
import Warning from 'components/Warning';
import { CaptchaGoogle, resetCaptcha } from 'components/CaptchaGoogle/CaptchaGoogle';
import { validateCyrillicName, validateEmail } from 'utils/reduxForm/validations';
import Loading from 'components/Loading';
import YaMapComponent from 'modules/App/components/YaMapComponent';
import { isRequiredFn } from 'modules/Taps/components/NDFL3/services/CommonValidations';

class ExternalAppointmentForm extends Component {
  state = {
    firstName: '',
    lastName: '',
    email: '',
    emailError: null,
    lastNameError: null,
    firstNameError: null,
    appointmentDate: '',
    appointmentTime: '',
    fnsServiceID: '',
    captchaKey: '',
    captchaIsLoaded: false,
    timeOptions: [],
    inspectionDetails: {},
  };

  componentDidUpdate(prevProps, prevState) {
    const { appointmentDate } = this.state;
    const { isMakeAppointmentError } = this.props;

    if (appointmentDate !== prevState.appointmentDate) {
      this.getTimeOptions();
    }
    if (isMakeAppointmentError && prevProps.isMakeAppointmentError !== isMakeAppointmentError) {
      resetCaptcha();
    }
  }

  getTimeOptions = () => {
    const { appointmentDate } = this.state;
    const { slots } = this.props;
    const daySlots = get(slots, appointmentDate && appointmentDate.format(DateFormats.long), []);
    const items = daySlots.map((slot) => {
      return {
        label: moment.parseZone(slot.visitTimeObject).format('HH:mm'),
        value: slot.visitTime,
        fnsserviceID: slot.fnsserviceID,
      };
    });
    this.setState({ timeOptions: items });
  };
  onSelectOtherInspection = (value) => {
    const { resetSlots } = this.props;
    if (value) {
      this.setState({ inspectionDetails: value });
      this.props.getSlots(value.id, GET_ACCESS_TO_LK_FNS_SERVICE_ID);
    } else {
      resetSlots();
    }
    this.setState({ appointmentDate: '', appointmentTime: '' });
  };

  onFirstNameChangeHandle = ({ target: { value } }) => {
    const firstNameError = isRequiredFn(value) || validateCyrillicName(value, false);
    this.setState({
      firstName: value,
      firstNameError,
    });
  };

  onLastNameChangeHandle = ({ target: { value } }) => {
    const lastNameError = isRequiredFn(value) || validateCyrillicName(value, false);
    this.setState({ lastName: value, lastNameError });
  };

  onSelectDateHandle = (value) => {
    this.setState({ appointmentDate: value });
  };
  onSelectTimeHandle = (e) => {
    this.setState({ appointmentTime: e.value, fnsServiceID: e.fnsserviceID });
  };
  onRecaptchaVerify = (captchaKey) => {
    this.setState({ captchaKey });
  };
  onEmailChangeHandle = ({ target: { value } }) => {
    const emailError = validateEmail(value, false);
    this.setState({ email: value, emailError });
  };

  isSubmitDisabled = () => {
    const { isSlotLoading } = this.props;
    const {
      firstName,
      lastName,
      appointmentDate,
      appointmentTime,
      captchaKey,
      emailError,
      firstNameError,
      lastNameError,
    } = this.state;
    const requiredValues = [
      firstName,
      lastName,
      appointmentDate,
      appointmentTime,
      !isSlotLoading,
      captchaKey,
      !emailError,
      !firstNameError,
      !lastNameError,
    ];
    return some(requiredValues, (value) => !value);
  };
  handleSubmit = (e) => {
    e.preventDefault();
    const {
      firstName,
      lastName,
      appointmentTime,
      inspectionDetails,
      fnsServiceID,
      captchaKey,
      email,
    } = this.state;
    this.props.onSubmit({
      data: {
        fnsId: inspectionDetails.id,
        codeSoun: inspectionDetails.codeSOUN,
        serviceName: GET_ACCESS_TO_LK_SERVICE_NAME,
        appointmentDateTime: moment.parseZone(appointmentTime).format('YYYY-MM-DD HH:mm:SS'),
        captchaKey,
        book: {
          fnsserviceID: fnsServiceID,
          visitTime: appointmentTime,
          faceID: defaultFaceId,
          lastName: lastName,
          firstName: firstName,
          middleName: '',
          mobilePhone: '',
          email,
          inn: '',
        },
      },
      taxAuthority: inspectionDetails,
    });
    this.setState({ captchaKey: null });
  };

  validationMessage = (key) => {
    const { [key]: stateValue } = this.state;
    const validators = {
      lastName: [isRequiredFn],
    };

    return validators[key].every((validator) => validator(stateValue));
  };

  render() {
    const {
      firstName,
      lastName,
      appointmentDate,
      appointmentTime,
      timeOptions,
      inspectionDetails,
      email,
      emailError,
      firstNameError,
      lastNameError,
    } = this.state;
    const {
      slotDates,
      isSlotLoading,
      isError,
      isMakeAppointmentLoading,
      isMakeAppointmentError,
    } = this.props;
    return (
      <React.Fragment>
        <div className={styles.contentBlock}>
          <h2 className={styles.title}>Получение доступа к Личному кабинету</h2>
          <div className={styles.mainBlock}>
            <div className={styles.formBlock}>
              <div className={styles.personalInfo}>
                <Field
                  label="Фамилия"
                  isRequired={true}
                  onChange={this.onLastNameChangeHandle}
                  onBlur={this.onLastNameChangeHandle}
                  value={lastName}
                  maxLength={60}
                  isValid={!lastNameError}
                  validationMessage={lastNameError}
                />
                <Field
                  label="Имя"
                  isRequired={true}
                  onChange={this.onFirstNameChangeHandle}
                  onBlur={this.onFirstNameChangeHandle}
                  value={firstName}
                  maxLength={60}
                  isValid={!firstNameError}
                  validationMessage={firstNameError}
                />
              </div>

              <Field
                label="Адрес электронной почты для отправки сведений о записи"
                onChange={this.onEmailChangeHandle}
                value={email}
                isValid={!emailError}
                validationMessage={emailError}
              />
              <TaxAuthoritySelectContainer onSelect={this.onSelectOtherInspection} />
              <div className={styles.dateBlock}>
                <SlotLoadingStatus isError={isError} isLoading={isSlotLoading}>
                  <DateField
                    startDateValue={appointmentDate}
                    isDisabled={isEmpty(slotDates)}
                    handleChangeStart={this.onSelectDateHandle}
                    label="Выберите дату *"
                    showMonthDropdown={false}
                    showYearDropdown={false}
                    peekNextMonth={false}
                    forceShowMonthNavigation={true}
                    includeDates={slotDates}
                  />
                  <Select
                    isDisabled={isEmpty(timeOptions)}
                    options={timeOptions}
                    label="Выберите время *"
                    style={{ width: '180px' }}
                    value={appointmentTime}
                    onChange={this.onSelectTimeHandle}
                  />

                  {!isSlotLoading && isEmpty(slotDates) && get(inspectionDetails, 'visible') && (
                    <Warning message={'Доступные даты для записи отсутствуют'} />
                  )}

                  {isMakeAppointmentError && <Warning message={isMakeAppointmentError} />}
                </SlotLoadingStatus>
              </div>
              <CaptchaGoogle
                verifyCallback={this.onRecaptchaVerify}
                expiredCallback={this.onRecaptchaVerify}
              />
            </div>
            <div className={styles.mapBlock}>
              {inspectionDetails.codeSOUN && inspectionDetails.address && (
                <YaMapComponent
                  addressId={inspectionDetails.codeSOUN}
                  address={inspectionDetails.address}
                />
              )}
            </div>
          </div>
        </div>
        <div className={styles.buttonBlock}>
          <Button
            type="button"
            href={routeMap.login}
            color={BUTTON_COLORS.WHITE_BLUE}
            hasWrapper={false}
          >
            Выйти
          </Button>
          <Button
            onClick={this.handleSubmit}
            isDisabled={this.isSubmitDisabled()}
            type="submit"
            hasWrapper={false}
            buttonStyle={{ position: 'relative', minWidth: '280px' }}
          >
            {isMakeAppointmentLoading ? <Loading isLight={true} /> : 'Записаться на приём'}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

ExternalAppointmentForm.propTypes = {
  getSlots: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  slotDates: PropTypes.array,
  slots: PropTypes.object,
  isSlotLoading: PropTypes.bool,
  isError: PropTypes.bool,
  isMakeAppointmentLoading: PropTypes.bool,
  isMakeAppointmentError: PropTypes.string,
  resetSlots: PropTypes.func.isRequired,
};

export default ExternalAppointmentForm;
